import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Thumbs, Autoplay, FreeMode } from 'swiper/modules';


let thumbsSwiper;

const thumbs = new Swiper(".investment-slider__thumbs", {
  modules: [FreeMode, Thumbs],
  spaceBetween: 10,
  autoplay: true,
  watchSlidesProgress: true,
  freeMode: false,
  allowTouchMove: true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  centeredSlides: false,
  touchRatio: 0.2,

});



const hero = new Swiper(".investment-slider__swiper", {
  modules: [Navigation, Pagination, EffectFade, Thumbs],
  loop: false,
  effect: "fade",
  allowTouchMove: true,
  slidesPerView:1,
  centeredSlides: true,


  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  thumbs: {
    swiper: thumbs,
  },
});

const gallery = new Swiper(".gallery-slider__swiper", {
  modules: [Navigation, Pagination, EffectFade, Thumbs],
  loop: false,
  effect: "fade",
  allowTouchMove: true,
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  }
});

const  slider = new Swiper(".myTeam", {
	modules: [Navigation, Pagination],

	slidesPerView: 1.3,
	spaceBetween: 16,
	loop: true,


	breakpoints: {

	  480: {
		slidesPerView: 1.3,
		spaceBetween: 20,

	  },
	  767: {
		slidesPerView: 1.4,
		spaceBetween: 20,

	  },
	  960: {
		slidesPerView: 2.2,
		spaceBetween: 20,

	  },

	  1280: {
		slidesPerView: 3,
		spaceBetween: 20,

	  }

	},
	navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
		el: ".swiper-pagination",
		clickable: true
	}

  });




